import { useEffect } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    context: 'appointment_overlay',
    path: 'patient_new.provider_employee_resource_id',
    viewPath: props.viewPath,
  })
  let scheduling = useDataValue({
    context: 'tab',
    path: 'scheduling',
    viewPath: props.viewPath,
  })
  let providers = useDataValue({
    context: 'providers',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (
      (scheduling.slot_id || scheduling.untemplated_slot.id) &&
      scheduling.provider_id
    ) {
      if (providers.find(item => item.id === scheduling.provider_id)) {
        change(scheduling.provider_id)
      }
    }
  }, [
    scheduling.slot_id,
    scheduling.untemplated_slot.id,
    scheduling.provider_id,
    providers,
  ])

  return <View {...props} />
}
